// YNX — SUPPORT MODULE (bug report + Emergent fallback)
import React, { useState } from 'react';
import { Send, LifeBuoy, ExternalLink, Bug, MessageCircle, Lightbulb, CreditCard } from 'lucide-react';
import { createSupportTicket } from '../../lib/biz';

const CATEGORIES = [
  { id: 'bug',     label: 'Bug', icon: Bug },
  { id: 'question',label: 'Question', icon: MessageCircle },
  { id: 'feature', label: 'Suggestion', icon: Lightbulb },
  { id: 'billing', label: 'Facturation YNX', icon: CreditCard },
];

export const SupportModule = ({ workspace }) => {
  const [category, setCategory] = useState('bug');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [email, setEmail] = useState(workspace?.owner_email || '');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async () => {
    if (!title.trim() || !description.trim()) { alert('Titre et description requis.'); return; }
    setBusy(true);
    try {
      await createSupportTicket({
        workspace_id: workspace?.id || '',
        user_email: email,
        category,
        title: title.trim(),
        description: description.trim(),
        page: window.location.pathname,
        user_agent: navigator.userAgent,
      });
      setSent(true);
      setTitle(''); setDescription('');
    } catch (e) { alert(e.message); }
    finally { setBusy(false); }
  };

  return (
    <div className='biz-module'>
      <header className='biz-module-head'>
        <h2><LifeBuoy size={18} style={{ verticalAlign: 'middle' }} /> Support YNX</h2>
      </header>

      <div className='biz-support-grid'>
        <section className='biz-support-form'>
          <h3>Ouvrir un ticket</h3>
          <p className='biz-section-help'>Décrivez votre problème, votre question ou votre suggestion. Carl TACITA et l'équipe vous répondront sous 24h ouvrées.</p>

          <div className='biz-cat-grid'>
            {CATEGORIES.map((c) => {
              const Icon = c.icon;
              return (
                <button
                  key={c.id}
                  className={`biz-cat-btn ${category === c.id ? 'active' : ''}`}
                  onClick={() => setCategory(c.id)}
                >
                  <Icon size={20} /> {c.label}
                </button>
              );
            })}
          </div>

          <label className='biz-label'>Votre email *</label>
          <input className='biz-input' name='sup-email' type='email' value={email} onChange={(e) => setEmail(e.target.value)} placeholder='vous@entreprise.fr' />

          <label className='biz-label'>Sujet *</label>
          <input className='biz-input' name='sup-title' value={title} onChange={(e) => setTitle(e.target.value)} placeholder='Résumé court du problème' />

          <label className='biz-label'>Description détaillée *</label>
          <textarea className='biz-input' name='sup-desc' rows={6} value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Étapes pour reproduire, message d'erreur, capture si possible…" />

          <button className='biz-btn-primary' onClick={submit} disabled={busy} data-testid='sup-send-btn' style={{ marginTop: 12 }}>
            <Send size={14} /> {busy ? 'Envoi…' : 'Envoyer le ticket'}
          </button>

          {sent && <div className='biz-banner success' style={{ marginTop: 12 }}>✓ Ticket envoyé. Nous vous répondrons par email.</div>}
        </section>

        <section className='biz-support-side'>
          <h3>Assistance Emergent</h3>
          <p className='biz-section-help'>YNX est hébergé chez <b>Emergent</b>. En cas de problème d'infrastructure, vous pouvez aussi contacter directement leur support.</p>
          <a href='https://app.emergent.sh' target='_blank' rel='noreferrer' className='biz-btn-ghost' style={{ display: 'inline-flex' }}>
            <ExternalLink size={12} /> Espace Emergent
          </a>

          <h3 style={{ marginTop: 24 }}>Documentation YNX</h3>
          <ul className='biz-support-links'>
            <li>📅 <b>Agenda</b> : créer, modifier ou supprimer des rendez-vous</li>
            <li>📋 <b>Tâches</b> : Kanban à 3 colonnes (à faire / en cours / terminé)</li>
            <li>🧾 <b>Devis & Factures</b> : numérotation automatique, TVA française, PDF prêt à imprimer</li>
            <li>👥 <b>Clients</b> : base de données avec recherche</li>
            <li>📞 <b>Annuaire interne</b> : extensions auto + messagerie inter-utilisateurs gratuite</li>
            <li>🎨 <b>Studio Visuel</b> : génération d'images / flyers via IA (gratuit)</li>
            <li>💬 <b>Assistant IA</b> : chat multimodèle (GPT, Claude, Gemini…) avec accès aux modules</li>
          </ul>

          <h3 style={{ marginTop: 24 }}>Vous voulez délocaliser YNX ?</h3>
          <p className='biz-section-help'>
            YNX est conçu pour être hébergé partout : Emergent (recommandé), OVH, Hetzner, AWS, votre propre serveur…
            Le dossier <code>/app/deploy</code> contient le mode d'emploi complet (Docker + .env). Demandez-le par ticket.
          </p>
        </section>
      </div>
    </div>
  );
};
